import { useQuery } from "@tanstack/react-query";

import { listOneCBases, ONEC_BASES_QUERY_KEY, type OneCBaseList } from "@/api/onec_bases";
import type { OneCConnectionView } from "@/types/api";

/** Справочник баз 1С + состояние сессии. Один ключ на шапку, менеджер
 *  подключений и админ-страницу: правка справочника сразу видна везде. */
export function useOneCBases(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ONEC_BASES_QUERY_KEY,
    queryFn: listOneCBases,
    enabled: options.enabled ?? true,
  });
}

/** Почему подключение не будет работать в SSO-сессии (бэкенд тогда ответит
 *  403 `onec_base_not_configured` / `onec_not_configured`); null — всё на месте. */
export function ssoConnectionProblem(
  conn: Pick<OneCConnectionView, "onec_base_id">,
  list: OneCBaseList,
): string | null {
  if (conn.onec_base_id === null) {
    return (
      "Адреса этого подключения нет в справочнике баз 1С — в SSO-сессии оно не работает. " +
      "Заведите подключение выбором базы из справочника или обратитесь к администратору."
    );
  }
  const base = list.bases.find((b) => b.id === conn.onec_base_id);
  if (!base) {
    // Рассинхрон ответов бэкенда — называем его, а не молчим.
    return `База ${conn.onec_base_id} не найдена в справочнике баз 1С — обратитесь к администратору.`;
  }
  if (!list.onec_metadata_keys.includes(base.metadata_key)) {
    return (
      `В учётной записи SSO не задан пользователь 1С для базы «${base.name}» ` +
      `(${base.metadata_key}) — обратитесь к администратору.`
    );
  }
  return null;
}
